<template>
  <div :class="wrapClass">
    <input-label :for-id="forId" :class-name="className" :content="content"></input-label>
    <span v-if="isRequired" :class="requiredLabelClass">
      {{ $t('common.required') }}
    </span>
    <span v-if="!isRequired" :class="anyLabelClass">
      {{ $t('common.any') }}
    </span>
  </div>
</template>

<script>
import InputLabel from '@/common/components/atoms/InputLabel'

export default {
  name: 'RequireLabel',
  components: { InputLabel },
  props: {
    wrapClass: {
      type: String,
      default: 'sm:px-0',
    },
    forId: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: 'text-black text-xs font-semibold',
    },
    content: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    requiredLabelClass: {
      type: String,
      default: 'text-red-600 ml-2 text-xs',
    },
    anyLabelClass: {
      type: String,
      default: 'text-gray-600 ml-2 text-xs bg-gray-200',
    },
  },
}
</script>

<style scoped>

</style>
